import Soprasteria from "./soprasteria";
export default Soprasteria;